import React from 'react';
import { CheckoutPayment } from '../presentation/CheckoutPayment';
import { OrderSummary } from '../presentation/OrderSummary';

export const Payment = () => {
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 h-full">
      <CheckoutPayment />
      <OrderSummary />
    </div>
  )
}